/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import { connect } from 'react-redux'

import { getRegionIds } from '@/reducers/regions'
import { fetchRegionListRequest } from '@/reducers/asyncRequests/registry'

import { fetchRegionListIfNeeded } from '../../../../../actions/regionEqualizer'

import ManageRegions from './ManageRegions'

const mapStateToProps = (state) => ({
  regionIds: getRegionIds(state),
  regionsRequest: fetchRegionListRequest(state),
})

const mapDispatchToProps = {
  fetchRegionListIfNeeded,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageRegions)
